module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("03X1i"))).then(() => parcelRequire('5erN3'));